define('modules/form_editor/models/custom_iban',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");
  module.exports = BaseFormElement.extend({
    name: "custom:iban",
    defaultValues: {
      "placeholder": "ESXX XXXX XXXX XXXX XXXX XXXX",
      "allowBBAN": false
    },
    defaultErrorMsgKey: "formEditor.validationMessages.iban"
  });
});

